import { useTranslation } from "react-i18next";
import CustomModal from "../../packages/CustomModal";

const NoStablePointsDialog = ({ show, onClose }) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <CustomModal
      show={show}
      confirmBtn={t("ValueStrings.okay")}
      width="640px"
      size="small"
      header={t("statusApiErrors.noStablePointsTitle")}
      onModalClose={onClose}
    >
      <div className="help-dialog-content">
        <div className="help-section">
          <div className="help-heading">
            {t("statusApiErrors.noStablePointsIntro")}
          </div>
          <ul className="help-list">
            <li className="help-list-item">
              {t("statusApiErrors.cipSchedule")}
            </li>
            <li className="help-list-item">{t("statusApiErrors.dataRange")}</li>
            <li className="help-list-item">
              {t("statusApiErrors.outlierSelection")}
            </li>
            <li className="help-list-item">
              {t("statusApiErrors.cipShutdownIdentification")}
            </li>
            <li className="help-list-item">
              {t("statusApiErrors.cleaningEffectivenessCalculation")}
            </li>
          </ul>
        </div>
        <div className="help-heading">
          {t("statusApiErrors.afterAdjustments")}
        </div>
      </div>
    </CustomModal>
  );
};

export default NoStablePointsDialog;
